import { Component } from '@angular/core';

@Component({
  selector: 'bb-showcase-web',
  templateUrl: './showcase-web.component.html',
  standalone: false,
})
export class ShowcaseWebComponent {}
